import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Box,
  GDSStyleObject,
  Fieldset,
  HeadingText,
  Radio,
  FormField,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../../assets/json/COB_QUESTIONER.json';
import { Calendar } from '../../../reusable-components/calendar/calendar';
import { isEmpty, isNotEmpty } from '../../../helpers/helpers';
import useCobStore from '../../../../store/cob-store';
import '../../forms.css';
import { COBLayout } from '../../../cob-layout/cob-layout';
// import { SimpleTestExample } from '../../../simple-test-example.component';

export const EmploymentStatus = forwardRef((props: any, ref) => {
  // export function EmploymentStatus(props: any) {
  const { nextButtonClicked, OPISResponseInfo, errorHandling, nextDisabled } =
    props;
  // const [hasEmpStatus, setHasEmpStatus] = useState(false);
  const isBelow400 = useMediaQuery(queryHelpers.down(400));

  const [hasEmploymentStatus, setHasEmploymentStatus] = useState(false);
  // const [isDateError, setIsDateError] = useState<boolean>(false);
  const dependantList = useCobStore((state: any) => state.demographics);
  let empStatusFlag: boolean = false;
  const [form, setForm] = useState({
    employmentStatus: OPISResponseInfo?.employmentStatus
      ? OPISResponseInfo?.employmentStatus
      : '',
    retiredDate: OPISResponseInfo?.retirementDate
      ? OPISResponseInfo?.retirementDate
      : '',
  });

  const [errors, setErrors] = useState({
    employmentStatus: false,
    retiredDate: false,
  });

  useEffect(() => {
    if (form.employmentStatus) {
      nextDisabled(false);
    } else {
      nextDisabled(true);
    }
  }, [nextDisabled, form.employmentStatus]);

  useEffect(() => {
    if (OPISResponseInfo.employmentStatus === 'R') {
      setHasEmploymentStatus(true);
    } else {
      setHasEmploymentStatus(false);
    }
  }, [setHasEmploymentStatus, OPISResponseInfo.employmentStatus]);

  const formField = isEmpty(form.employmentStatus) || isEmpty(form.retiredDate);

  // const isValid = checkFormValid();

  useEffect(() => {
    const checkFormValid = () => {
      if (hasEmploymentStatus) {
        return isNotEmpty(form.employmentStatus) && empStatusFlag
          ? isEmpty(form.retiredDate)
          : isNotEmpty(form.retiredDate);
      }
      return isNotEmpty(form.employmentStatus);
    };

    if (checkFormValid()) {
      setErrors({
        employmentStatus: false,
        retiredDate: false,
      });
      errorHandling(true);
      // setIsDateError(false);
    } else {
      // setIsDateError(false);
      errorHandling(false);
    }
  }, [
    nextButtonClicked,
    hasEmploymentStatus,
    form.employmentStatus,
    form.retiredDate,
    errorHandling,
    formField,
    errors.employmentStatus,
    errors.retiredDate,
    empStatusFlag,
  ]);

  const updateHandler = (event: any) => {
    const { value, id } = event.target ? event.target : event;
    const nextFormState = {
      ...form,
      [id]: value,
    };
    if (event?.target) {
      form.employmentStatus = event.target.value;
      OPISResponseInfo.employmentStatus = event.target.value;
      // setHasEmpStatus(event.target.value);
      if (event.target.value === 'R') {
        empStatusFlag = true;
        setHasEmploymentStatus(true);
        // setIsDateError(false);
        setErrors({
          employmentStatus: false,
          retiredDate: false,
        });
      } else {
        empStatusFlag = false;
        // setIsDateError(false);
        OPISResponseInfo.retirementDate = '';
        form.retiredDate = '';
        nextFormState.retiredDate = '';
        setHasEmploymentStatus(false);
        setErrors({
          employmentStatus: false,
          retiredDate: false,
        });
        errorHandling(false);
      }
    } else {
      OPISResponseInfo.retirementDate = nextFormState.retiredDate;
      if (formField || (errors.employmentStatus && errors.retiredDate)) {
        errorHandling(false);
      } else {
        errorHandling(true);
      }
    }

    setForm({
      employmentStatus: form.employmentStatus,
      retiredDate: nextFormState.retiredDate,
    });
    setErrors({
      ...errors,
      [id]: isEmpty(value),
    });
  };

  const selectedRetiredDate = (selectedDate: string) => {
    updateHandler({ value: selectedDate, id: 'retiredDate' });
  };

  useImperativeHandle(ref, () => ({
    callValidation() {
      if (hasEmploymentStatus || isEmpty(form.retiredDate)) {
        setErrors({
          employmentStatus: isEmpty(form.employmentStatus),
          retiredDate: isEmpty(form.retiredDate),
        });
      } else {
        setErrors({
          employmentStatus: false,
          retiredDate: false,
        });
      }
    },
  }));

  return (
    <COBLayout
      title={
        OPISResponseInfo?.member?.firstName ===
          dependantList.demographics?.firstName &&
        OPISResponseInfo.member?.dateOfBirth ===
          dependantList?.demographics?.dateOfBirth
          ? COBQuestioner.COB.INFORMATION.YOUROTHERINSURANCE
          : `${`${OPISResponseInfo.member.firstName} ${OPISResponseInfo.member.lastName}${COBQuestioner.COB.INFORMATION.DEPENDENTOTHERINSURANCE}`}`
      }
      dataTestId="employment-status"
      questionTitle={
        COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.TITLE
      }
      disclaimer={
        COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.SELECTONE
      }
      isDependant={false}
    >
      <Box
        css={
          {
            marginBottom: '15px',
          } as GDSStyleObject
        }
      >
        <Fieldset
          legend=""
          id="otherEmploymentStatus"
          css={
            { marginTop: '$half', borderRadius: '$medium' } as GDSStyleObject
          }
          inputStatus={errors.employmentStatus ? 'error' : undefined}
        >
          <Box className="GDS-radio-warapper marginBottom15">
            <Radio
              data-testid="active-status"
              id="employmentStatus-1"
              name="employmentStatus"
              value={
                COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.ACTIVE
                  ? 'A'
                  : ''
              }
              label={
                COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.ACTIVE
              }
              style={{ color: 'blue' }}
              layout="row"
              onChange={(e) => {
                updateHandler(e);
              }}
              checked={
                OPISResponseInfo?.employmentStatus === 'A' ||
                form.employmentStatus === 'A'
              }
            />
          </Box>
          <Box className="GDS-radio-warapper marginBottom15">
            <Radio
              data-testid="retired-status"
              id="employmentStatus-2"
              name="employmentStatus"
              value={
                COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.RETIRED
                  ? 'R'
                  : ''
              }
              label={
                COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.RETIRED
              }
              layout="row"
              required
              onChange={(e) => {
                updateHandler(e);
              }}
              checked={
                OPISResponseInfo?.employmentStatus === 'R' ||
                form.employmentStatus === 'R'
              }
            />
          </Box>
          <Box className="GDS-radio-warapper">
            <Radio
              id="employmentStatus-3"
              name="employmentStatus"
              value={
                COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.COBRA ===
                'COBRA'
                  ? 'C'
                  : ''
              }
              label={
                COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.COBRA
              }
              layout="row"
              onChange={(e) => {
                updateHandler(e);
              }}
              checked={
                OPISResponseInfo?.employmentStatus === 'C' ||
                form.employmentStatus === 'C'
              }
            />
          </Box>
        </Fieldset>
      </Box>

      {hasEmploymentStatus && (
        <Box>
          <HeadingText
            level="3"
            size={{
              '@initial': 'xl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xl',
              '@desktop': 'xl',
            }}
            css={{ marginTop: '$half', marginBottom: '$one' } as GDSStyleObject}
          >
            {' '}
            {COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.RETIREMENT}
          </HeadingText>

          <FormField
            id="retiredDate"
            label={
              COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS
                .RETIREMENTDATE
            }
            aria-label={
              COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS
                .RETIREMENTDATE
            }
            css={
              {
                marginBottom: '$one',
                '& label': {
                  marginBottom: '10px',
                },
              } as GDSStyleObject
            }
          >
            {' '}
            <Calendar
              selectedFormatDate={selectedRetiredDate}
              currentDate={`${OPISResponseInfo?.retirementDate}`}
              showError={errors.retiredDate}
              errorMessage={COBQuestioner.COB.ERRORS.REQUIRED}
              setWidth={isBelow400 ? '105px' : '110px'}
              data-testid="calendar"
            />
          </FormField>
        </Box>
      )}
    </COBLayout>
  );
});
